import * as d3 from 'd3';
import { ElementRender } from './ElementeRenderer';
import { ItemFormat } from '../interfaces';
import { RoundingHelper } from '../../..';


export class Line extends ElementRender {
    private _lineGenerator: d3.svg.Line<ItemFormat>;
    private _color: string;
    constructor(selection: d3.Selection<any>) {
        super(selection, 'line');
        this.container()
            .append('path')
            .style('fill', 'none');
        this._lineGenerator = d3.svg.line<ItemFormat>()
            .x(d => RoundingHelper.notNaN(d.x + d.width / 2, 0))
            .y(d => RoundingHelper.notNaN(d.y, 0));
    }

    color(): string;
    color(value: string): this;
    color(value?: string): this | string {
        if (!arguments.length) {
            return this._color;
        }
        this._color = value;
        return this;
    }

    render(data: ItemFormat[]) {
        this.container()
            .classed('hidden-group', !this.visible())
            .select('path')
            .transition()
            .attr('d', this._lineGenerator(data))
            .style('stroke', this._color);
    }
}